"use client"

import { CircleArrowOutUpRight } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CircleArrowOutUpRightIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CircleArrowOutUpRightIcon = component(Icon)({
  as: CircleArrowOutUpRight,
})
